import React, { Component } from 'react';

import { UTILITY_USER_ROLE_ADMIN } from 'common/utility/userRoles';

import branch from 'client/core/branch';
import withScreenId from 'client/helpers/withScreenId';
import withTransitionHook from 'client/helpers/withTransitionHook';
import allowedUtilityRoles from 'client/helpers/allowedUtilityRoles';
import withScrollToTop from 'client/helpers/withScrollToTop';
import { SCREEN_ID_UTILITY_PROFIT_ADMIN_ACCOUNTING_NON_INTERNET_DASHBOARD } from 'client/constants/screenIds';

import UtilityActivationActions from 'client/actions/UtilityActivation';

import SrPartnerPageV2 from 'client/components/SrPartnerPageV2/SrPartnerPageV2';
import UPAdminAccountingNonInternetDashboard from '../../components/UPAdminAccountingNonInternetDashboard/UPAdminAccountingNonInternetDashboard';

@withTransitionHook
@withScreenId(SCREEN_ID_UTILITY_PROFIT_ADMIN_ACCOUNTING_NON_INTERNET_DASHBOARD)
@withScrollToTop
@allowedUtilityRoles({
  roles: [UTILITY_USER_ROLE_ADMIN],
})
@branch({
  utilityTypes: ['utilityActivations', 'types'],
})
class UtilityProfitAdminAccountingNonInternetDashboardPage extends Component {
  static getPageMetadata = () => ({
    pageTitle: 'Accounting Dashboard (Non-Internet) | Utility Profit',
  });

  static fetchData(match, inject) {
    return Promise.all([UtilityActivationActions.getTypesList(inject)]);
  }

  render() {
    const { utilityTypes } = this.props;

    return (
      <SrPartnerPageV2
        navbarTitle="Utility Profit Admin"
        navbarImage="/images/utility-profit-logo.svg"
        backUrl="/utility-profit/admin"
        redirectToLastLocation={false}
        maxWidth="100%"
      >
        <UPAdminAccountingNonInternetDashboard utilityTypes={utilityTypes} />
      </SrPartnerPageV2>
    );
  }
}

export default UtilityProfitAdminAccountingNonInternetDashboardPage;
